import React from 'react';
import { Typography } from "@mui/material";

export function SectionHeader({ header }) {
    return (
        <Typography variant="h5" component="h3" fontWeight={600} marginBottom={{ xs: "24px", sm: "40px" }}>{header}</Typography>
    );
}
